module.exports = __webpack_public_path__ + "static/media/msc_white_logo.7927061c.png";